export default __webpack_public_path__ + "static/media/city.6e056a4c.webp";